import styled from 'styled-components';
import { RoundButton } from '../button';
import type { SquareButtonProps } from '../button/square-button';
import colors from '../../style/colors';

const PaginationButton = styled(RoundButton)<SquareButtonProps>`
  &,
  &:focus,
  &:focus-visible {
    background-color: transparent;
    border-color: transparent;
    color: ${colors.black};
  }

  &:hover:not(.disabled):not([disabled]) {
    background-color: ${colors.gray300};
    border-color: ${colors.gray300};
    color: ${colors.black};
  }

  &.active:not(.disabled):not([disabled]),
  &:active:not(.disabled):not([disabled]) {
    background-color: ${colors.black};
    border-color: ${colors.black};
    color: ${colors.white};
  }

  &.active:hover:not(.disabled):not([disabled]),
  &:active:hover:not(.disabled):not([disabled]) {
    background-color: ${colors.black};
    border-color: ${colors.black};
    color: ${colors.white};
  }
`;

export default PaginationButton;
